import { render, staticRenderFns } from "./XcqSamallImg.vue?vue&type=template&id=0863f428&scoped=true&"
import script from "./XcqSamallImg.vue?vue&type=script&lang=ts&"
export * from "./XcqSamallImg.vue?vue&type=script&lang=ts&"
import style0 from "./XcqSamallImg.vue?vue&type=style&index=0&id=0863f428&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0863f428",
  null
  
)

export default component.exports